import type { EngineProfile } from "@/runtime/events";

export const LOCAL_PROFILE: EngineProfile = {
  vad: "local-silero",
  stt: "local-moonshine-tiny-en-q4",
  llm: "local-qwen",
  tts: "local-moss",
};

export const HYBRID_PROFILE: EngineProfile = {
  vad: "local-silero",
  stt: "local-moonshine-tiny-en-q4",
  llm: "cloud-websocket",
  tts: "cloud-websocket",
};
